import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import Table from '../../../common/Table';
import { getRegisteredBusFleets } from '../../../../actions';
import { REGISTERED_BUS_FLEET_COLUMNS } from '../../../../config/columns';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { INT_DATE_FORMAT } from '../../../../config/locale';
import { tzNormalizeDate } from '../../../../utils/date';
import RegisteredBusFleetSearchForm from './RegisteredBusFleetSearchForm';

const BusFleetHistoryPanel = ({
  fleets,
  loading,
  dispatchGetRegisteredBusFleets,
}) => {
  const handleSearch = ({
    fromDateString,
    toDateString,
    baseLocation,
    serviceType,
    showNorthChico,
    showMine,
  }) => {
    const newFormValues = {
      fromDateString: tzNormalizeDate({
        date: fromDateString,
        format: INT_DATE_FORMAT,
      }),
      toDateString: tzNormalizeDate({
        date: toDateString,
        format: INT_DATE_FORMAT,
      }),
      showNorthChico: showNorthChico || false,
      showMine: showMine || false,
    };

    if (baseLocation) {
      newFormValues.baseLocationId = baseLocation.value;
    }

    if (serviceType && serviceType.length) {
      newFormValues.serviceTypeIds = serviceType.map(({ value }) => value);
    }

    dispatchGetRegisteredBusFleets(newFormValues);
  };

  const data = fleets.get('content') || [];

  return (
    <>
      <RegisteredBusFleetSearchForm
        onSubmit={handleSearch}
        initialValues={{
          fromDateString: tzNormalizeDate(),
          toDateString: tzNormalizeDate(),
        }}
        loading={loading}
      />
      <Table
        columns={REGISTERED_BUS_FLEET_COLUMNS}
        data={data}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        manual={false}
        loading={loading}
        filterable
      />
    </>
  );
};

BusFleetHistoryPanel.propTypes = {
  fleets: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchGetRegisteredBusFleets: PropTypes.func.isRequired,
};

const mapStateToProps = ({ BusUnit }) => ({
  fleets: BusUnit.RegisteredBusFleet.getIn(['all', 'content']),
  loading: BusUnit.RegisteredBusFleet.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetRegisteredBusFleets: getRegisteredBusFleets,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusFleetHistoryPanel);
